import styled from "@emotion/styled";
import { useIsMobile } from "hooks/useDeviceType";

export const FilterContainer = styled.div(() => {
  const isMobile = useIsMobile();
  return {
    padding: isMobile ? "10px 0" : 0,
    marginBottom: isMobile ? "10px" : "12px",
    display: "flex",
    fontSize: "14px",
    width: "100%",
    overflowX: "scroll",
    overflowY: "hidden",

    // Hide scrollbar
    msOverflowStyle: "none",
    scrollbarWidth: "none",
    "::-webkit-scrollbar": {
      display: "none",
    },
  };
});
